(() => {
  'use strict';
  if (window.__gnwStudioV8) return;
  window.__gnwStudioV8 = true;
  // Informational samples only: no product options, cart writes or font substitution.
  const dialog = document.getElementById('GnwSamplesDialogV8');
  let returnFocus;
  if (dialog) {
    dialog.querySelector('[data-gnw-samples-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('gnwv8-dialog-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
      returnFocus = null;
    });
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  }
  document.addEventListener('click', e => {
    const summary = e.target.closest && e.target.closest('[data-gnw-sample-fold] > summary');
    if (summary && dialog && typeof dialog.showModal === 'function') {
      e.preventDefault();
      returnFocus = summary;
      dialog.querySelector('h2').textContent = summary.dataset.gnwSampleTitle;
      const target = dialog.querySelector('[data-gnw-samples-body]');
      target.replaceChildren(summary.parentElement.querySelector('[data-gnw-sample-content]').cloneNode(true));
      if (!dialog.open) dialog.showModal();
      target.scrollTop = 0;
      document.documentElement.classList.add('gnwv8-dialog-open');
    }
    const group = e.target.closest && e.target.closest('[data-gnw-group-open]');
    if (group) {
      const panel = document.getElementById(group.dataset.gnwGroupOpen);
      if (panel) {
        document.querySelectorAll('[data-gnw-group-panel]').forEach(item => item.open = item === panel);
        // Keep the anchor URL and native scroll behaviour as a non-JS fallback.
        requestAnimationFrame(() => panel.querySelector('summary').focus({preventScroll:true}));
      }
    }
  });
  const openHash = () => {
    try {
      const panel = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (panel && panel.matches('[data-gnw-group-panel]')) panel.open = true;
    } catch (_) { /* An unrelated/malformed fragment must not break navigation. */ }
  };
  addEventListener('hashchange', openHash);openHash();

  // Tab-local return context. Only public content URLs; never cart, checkout,
  // account URLs, form values or personalization properties. Search/filter
  // parameters are kept only as part of the chosen return URL. No analytics.
  const key = 'gnw:v8:navigation';
  const restoreKey = 'gnw:v8:restore';
  const store = {
    get(k) {try{return JSON.parse(sessionStorage.getItem(k));}catch(_){return null;}},
    set(k,v) {try{sessionStorage.setItem(k,JSON.stringify(v));}catch(_){}},
    remove(k) {try{sessionStorage.removeItem(k);}catch(_){}}
  };
  const safe = raw => {
    try {
      const u = new URL(raw,location.href);
      if (u.origin !== location.origin || u.username || u.password || !/^https?:$/.test(u.protocol)) return null;
      const normalized = u.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i,'');
      if (normalized !== '/' && !/^\/(?:collections|products|pages|blogs|search)(?:\/|$)/.test(normalized)) return null;
      const q = new URLSearchParams();
      for (const [name,value] of u.searchParams) {
        if (['sort_by','page','type','q','view','preview_theme_id'].includes(name) || name.startsWith('filter.')) q.append(name,value);
      }
      u.search=q.toString();
      if (!/^#(?:GnwGroup-|products|collection|shopify-section-)[\w-]*$/.test(u.hash)) u.hash='';
      return u;
    } catch (_) {return null;}
  };
  const publicPath = u => u.pathname;
  const relative = u => u.pathname+u.search+u.hash;
  const isFresh = info => info && Number.isFinite(info.at) && Date.now()-info.at >= 0 && Date.now()-info.at < 30*60*1000;
  const back = document.querySelector('[data-gnw-back]');
  let returnScroll;
  const ctx=store.get(key);store.remove(key);
  const current=safe(location.href);
  const prior=ctx && safe(ctx.from);const dest=ctx && safe(ctx.to);
  if (back && current) {
    if (isFresh(ctx) && prior && dest && publicPath(dest) === publicPath(current) && publicPath(prior) !== publicPath(current)) {
      back.href=relative(prior);returnScroll=Math.max(0,Math.min(Number(ctx.scroll)||0,1000000));
    } else {
      const ref=safe(document.referrer);
      if (ref && ref.pathname !== current.pathname) back.href=relative(ref);
    }
  }
  const restore=() => {
    const target=store.get(restoreKey),u=target && safe(target.url),here=safe(location.href);
    if (isFresh(target) && u && here && u.pathname+u.search === here.pathname+here.search) {
      store.remove(restoreKey);
      requestAnimationFrame(()=>requestAnimationFrame(()=>scrollTo({top:Math.max(0,Number(target.scroll)||0),behavior:'instant'})));
    }
  };
  addEventListener('pageshow',restore);if(document.readyState==='complete')restore();
  document.addEventListener('click',e=>{
    const a=e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('download') || a.target==='_blank' || e.button>0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const from=safe(location.href),to=safe(a.href);
    if(!from || !to || from.pathname===to.pathname) return;
    if (a.matches('[data-gnw-back]') && returnScroll !== undefined) store.set(restoreKey,{url:relative(to),scroll:returnScroll,at:Date.now()});
    store.set(key,{from:relative(from),to:relative(to),scroll:scrollY,at:Date.now()});
  });
})();
